import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class PalletItem extends Model {
  @Expose() id: number;
  @Expose() itemDescription: string;
  @Expose() quantity: number;
  @Expose() batch: string;
  @Expose() genericNumber: number;
  @Expose() tradeCode?: number;
  @Expose() acceptedQuantity: number;
  @Expose() rejectedQuantity: number;
}
